<form [formGroup]="form">
  <div class="sections">
    <section>
      <mat-form-field appearance="outline">
        <mat-label>Site Code</mat-label>
        <input matInput formControlName="siteCode" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Site Name</mat-label>
        <input matInput formControlName="siteName" />
      </mat-form-field>
    </section>
  </div>
  <div class="actions">
    <button mat-flat-button (click)="onCancel()">Cancel</button>
    <button color="primary" [disabled]="!form.valid" mat-flat-button (click)="onAdd()">Add</button>
  </div>
</form>
